import {
  callCallback,
  createContentRequest,
  stopLoadingShowError,
} from "../../utils";
import * as tvx from "../../lib/tvx-plugin-module.min";
import {
  MSXMenuRoot,
  MSXContentRoot,
  Tools,
  MSXContentItem,
  MSXContentPage,
} from "../../lib/tvx-plugin-module.min";

import { res_home } from "../../static-res";
import { studioRow } from "./studios-row";
import { createCollectionRow } from "../collections-row";
import { PagesEnum } from "../../api/api-models";
import { getPageCollections } from "../../api/worker";
import { sendSessionAnalytics, generateVisitorId } from "../../analytics";

export function createHomeRoot(callback: (data: any) => void): void {
  // --- АНАЛИТИКА СЕССИИ (только один раз за сессию) ---
  const sessionSent = sessionStorage.getItem("screenify:sessionAnalyticsSent");
  if (!sessionSent) {
    const userId = localStorage.getItem("screenify:userId") || "unknown";
    sendSessionAnalytics({
      userid: userId,
      email: localStorage.getItem("screenify:email") || "unknown",
      visitorId: generateVisitorId(userId),
    });
    sessionStorage.setItem("screenify:sessionAnalyticsSent", "true");
  }
  // --- КОНЕЦ АНАЛИТИКИ ---
  tvx.InteractionPlugin.stopLoading();
  getPageCollections(PagesEnum.HOME).then((homePage) => {
    if (homePage != null) {
      const collectionsWithMovies = homePage.collections;

      const homeRoot: MSXContentRoot = {
        cache: true,
        restore: true,
        reuse: true,
        type: "list",
        headline: res_home(),
        flag: "home",
        important: true,
        pages: [studioRow()],
      };
      collectionsWithMovies
        .sort((a, b) => a.position - b.position)
        .forEach((collectionWithFictions) => {
          homeRoot.pages.push(createCollectionRow(collectionWithFictions));
        });
      callCallback(homeRoot, callback);
    } else {
      console.log("error occured");
      stopLoadingShowError({}, callback);
    }
  });
}
